import { render } from "./SFormElementEmailInput.vue?vue&type=template&id=b53bc2f0"
import script from "./SFormElementEmailInput.vue?vue&type=script&lang=js"
export * from "./SFormElementEmailInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__